/**
 * Safely decode HTML entities in text
 * This function handles common HTML entities like &lt;, &gt;, &amp;, &quot;, &#39;
 * without using dangerouslySetInnerHTML to avoid XSS risks
 */
export function decodeHtmlEntities(text: string): string {
  const entityMap: Record<string, string> = {
    '&lt;': '<',
    '&gt;': '>',
    '&amp;': '&',
    '&quot;': '"',
    '&#39;': "'",
    '&#x27;': "'",
    '&#x2F;': '/',
    '&#x60;': '`',
    '&#x3D;': '=',
  }

  return text.replace(/&[#\w]+;/g, (entity) => {
    return entityMap[entity] || entity
  })
}